<template>
  <div class="main">
    <div class="b1"></div>
    <div class="b2"></div>
    <div class="b3"></div>
    <transition name="fade" :duration="1000">
      <ns-letter v-if="inited && mode===3" v-on:complete="letterComplete" v-on:startBg="startBg" v-on:endBg="endBg" :country="country" :countryCode="countryCode" :countryLanguage="countryLanguage"></ns-letter>
    </transition>
    <transition name="fade" :duration="1000">
      <ns-map v-if="delayed" v-show="inited && mode===2" v-on:complete="mapComplete" :autoCountry="autoCountry"></ns-map>
    </transition>
    <a href="javascript:void(0);" v-if="showMusic" :class="`music ${playing?'current':''}`" @click="openOrCloseSound"></a>
    <transition name="fade" :duration="1000">
      <nsWelAni v-if="!videoEnded" v-show="inited && mode===1" v-on:complete="welcomeComplete" v-on:vend="vend" ref="wel-video"></nsWelAni>
    </transition>

    <!--  <ns-frame v-if="inited && mode===4" v-on:complete="frameComplete" :country="country" :countryCode="countryCode" :countryLanguage="countryLanguage"></ns-frame>
      <ns-chmap v-if="inited && mode===5" v-on:complete="chMapComplete" :country="country" :countryCode="countryCode" :countryLanguage="countryLanguage"></ns-chmap>-->


  </div>
</template>

<style scoped>
a.music {
  opacity: 0.7;
  display: block;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 30px;
  top: 20px;
  background-image: url(../../assets/images/letter/music.png);
}

a.music.current {
  opacity: 1;
}
</style>

<script>
import nsWelAni from './comp/ns-wel-ani'
import nsMap from './comp/ns-map'
import nsLetter from './comp/ns-letter'
import nsFrame from './comp/ns-frame'

export default {
  components: {
    nsWelAni,
    nsMap,
    nsLetter,
    nsFrame
  },
  name: 'ns-main',
  data() {
    return {
      delayed: false,
      videoEnded: false,
      inited: false,
      mode: 1,
      country: '',
      countryCode: '',
      countryLanguage: [],
      autoCountry: "",
      playing: this.$helper.data.bging,
      showMusic: false,
    }
  },
  created() {

  },
  methods: {

    startBg() {
      this.$helper.data.bging = true;
      this.playing = true;
    },
    endBg() {
      this.$helper.data.bging = false;
      this.playing = false;
    },

    openOrCloseSound() {
      if (this.$helper.data.sound) {
        if (this.$helper.data.bging) {
          this.$helper.data.sound.paused = true;
          this.$helper.data.bging = false;
          this.playing = false;
        } else {
          this.$helper.data.sound.paused = false;
          this.$helper.data.bging = true;
          this.playing = true;
        }
      } else {
        this.$helper.data.sound = createjs.Sound.play("bg-sound", this.$helper.data.soundProp);
        this.$helper.data.bging = true;
        this.playing = true;
      }
    },
    getLocal() {
      if (this.$i18n.availableLocales.filter((item) => {
        return item === this.$i18n.locale
      }).length > 0) {
        return this.$i18n.locale;
      } else {
        return this.$i18n.fallbackLocale;
      }
    },
    vend() {
      this.videoEnded = true;
    },
    /*    chMapComplete() {
          //进入下一个环节
          this.mode = 6;
        },
        frameComplete() {
          //进入下一个环节
          this.mode = 5;
        },*/
    letterComplete() {
      //进入下一个环节
      //this.mode = 4;
      //走了，再见
      //window.location.href = "/pc/pages/" + this.getLocal().replace("zh", "cn").replace("ja", "jp") + "/?country=" + this.countryCode.toLowerCase() + "&languages=" + JSON.stringify(this.countryLanguage);
      window.location.href = "http://www.firstep.cn/temp/2020tygcs/" + this.getLocal().replace("zh", "cn").replace("ja", "jp") + "/?country=" + this.countryCode.toLowerCase() + "&languages=" + JSON.stringify(this.countryLanguage);
    },
    mapComplete(data) {
      console.log(data);
      this.country = data.countryName;
      this.countryCode = data.countryCode;
      this.countryLanguage = data.countryLanguage;
      //console.log(data);
      //进入下一个环节
      this.mode = 3;
    },
    welcomeComplete() {
      //进入下一个环节
      this.mode = 2;
    }
  },
  mounted() {
    setTimeout(() => {
      this.inited = true;
    }, 0);
    setTimeout(() => {
      this.delayed = true;
    }, 2000);
    setTimeout(() => {
      this.$refs["wel-video"].play();
      $(".loading").fadeOut(800, () => {
        $(this).remove();
        if (!this.$helper.data.sound) {
          this.$helper.data.sound = createjs.Sound.play("bg-sound", this.$helper.data.soundProp);
          this.$helper.data.bging = true;
          this.playing = true;

          //显示音乐按钮
          this.showMusic = true;

          setTimeout(() => {
            //console.log("haha");
            //console.log(this.$helper.data.sound);
            if (this.$helper.data.sound.position === 0) {
              //未播放成功
              this.$helper.data.bging = false;
              this.playing = false;
              this.$helper.data.sound.destroy();
              this.$helper.data.sound = null;
            }
          }, 1000);
        }
      })
    }, 1500);
  }
}
</script>
<style scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #0b1a4b;
}

.b1 {
  background-image: url(../../assets/images/letter/sheet.png);
}

.b2 {
  background-image: url(../../assets/images/letter/def.png);
}

.b3 {
  background-image: url(../../assets/images/letter/bg.png);
}
</style>
